import React, { Component } from 'react'
import styled from '@emotion/styled'
import Sentry from 'config/sentry'
import {
  ErrorContainer,
  ErrorContent,
  ErrorFooter,
  ErrorPage
} from 'components/ErrorPage'
import { Button, ButtonLink, spacer } from 'stylist'

const HomeLink = styled(ButtonLink)`
  margin-right: ${spacer(1)};
`

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Sentry.configureScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
    })
    Sentry.captureException(error)
  }

  render() {
    return this.state.error ? (
      <ErrorPage>
        <ErrorContainer>
          <h1>Oops, something went wrong</h1>
          <ErrorContent>
            Our team has been notified. If you would like to fill out an error
            report, please click below.
          </ErrorContent>
          <ErrorFooter>
            <HomeLink
              kind="standard"
              dark
              to="/"
              onClick={() => this.setState({ error: null })}
            >
              Home
            </HomeLink>
            <Button kind="primary" onClick={() => Sentry.showReportDialog()}>
              Fill out a report
            </Button>
          </ErrorFooter>
        </ErrorContainer>
      </ErrorPage>
    ) : (
      this.props.children
    )
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js